package one.healthium.profile.ui.avatar

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class UserAvatarViewModel(
    private val userInteractor: UserInteractor
) : BaseViewModel() {

    private val _state = MutableStateFlow(UserAvatarUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()

    init {
        launch {
            userInteractor.observeUser()
                .onEach { user ->
                    _state.update {
                        it.copy(userModel = user)
                    }
                }
                .catch {
                    Logger.e("Failed to observe user", it)
                }
                .launch()
        }
    }

    fun onAvatarUpdated(avatar: ByteArray) {
        launchGlobal {
            _state.value = _state.value.copy(loading = true)
            try {
                userInteractor.setAvatar(avatar)
            } catch (e: Exception) {
                Logger.e("Failed to update avatar", e)
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.value = _state.value.copy(loading = false)
            }
        }
    }

    fun onDeleteAvatarClicked() {
        launchGlobal {
            _state.value = _state.value.copy(loading = true)
            try {
                userInteractor.deleteAvatar()
            } catch (e: Exception) {
                Logger.e("Failed to update avatar", e)
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.value = _state.value.copy(loading = false)
            }
        }
    }
}